// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__bMv_M","rootNoMargin":"styles_rootNoMargin__YNSQq"};